import React from 'react';

export function EmailIcon(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26.667" height="26.667" viewBox="0 0 65 52">
            <path id="Icon_material-email" data-name="Icon material-email" d="M61.5,6H9.5a6.491,6.491,0,0,0-6.467,6.5L3,51.5A6.519,6.519,0,0,0,9.5,58h52A6.519,6.519,0,0,0,68,51.5v-39A6.519,6.519,0,0,0,61.5,6Zm0,13-26,16.25L9.5,19V12.5l26,16.25,26-16.25Z" transform="translate(-3 -6)" fill="#fff" />
        </svg>
    );
}